define.alias("ember-power-select/helpers/ember-power-select-is-group", "media/helpers/ember-power-select-is-group");